import { BooleanCapabilityKey } from '../plans/types';

export const CAPABILITY_UPGRADE_COPY: Record<
  BooleanCapabilityKey,
  { title: string; description: string }
> = {
  stripeBilling: {
    title: 'Collect payments with Stripe',
    description:
      'Upgrade to connect Stripe and manage billing in one place — charge memberships, send self-service payment links so parents can update cards from anywhere, apply balance adjustments, and configure family discounts. Students and parents also receive automated expiring-card reminders, so you\'re not stuck chasing down updated payment info. AI-powered retention metrics help you spot at-risk students before they leave.',
  },
  stripeConnect: {
    title: 'Connect your Stripe account',
    description:
      'Upgrade to a paid plan to link Stripe and accept tuition, fees, and card payments from students.',
  },
  kiosk: {
    title: 'Student sign-in kiosk',
    description: 'Upgrade to enable self check-in at your front desk.',
  },
  messagingEmail: {
    title: 'Email messaging',
    description:
      'Upgrade for more email templates and advanced email features.',
  },
  messagingSms: {
    title: 'SMS messaging',
    description: 'Upgrade to send text messages to students and leads.',
  },
  messagingPush: {
    title: 'Push notifications',
    description: 'Upgrade to send push notifications to your team.',
  },
  aiDropoffRisk: {
    title: 'Retention risk',
    description: 'Upgrade to unlock AI retention insights and alerts.',
  },
  aiLeadScoring: {
    title: 'AI lead scoring',
    description: 'Upgrade to score and prioritize leads automatically.',
  },
  aiCompose: {
    title: 'Write with AI',
    description: 'Upgrade to compose emails and SMS with AI assistance.',
  },
  aiChatbot: {
    title: 'Ask Sifu',
    description: 'Upgrade to ask Sifu how-to questions from anywhere in the app.',
  },
  dashboardFullAnalytics: {
    title: 'Full analytics dashboard',
    description: 'Upgrade to unlock revenue, retention, and growth metrics.',
  },
  websiteForms: {
    title: 'Website lead forms',
    description: 'Upgrade to embed lead capture forms on your website.',
  },
  leadAutomation: {
    title: 'Lead automation',
    description: 'Upgrade to automate follow-ups and appointment booking.',
  },
  eventPaidRegistration: {
    title: 'Paid event registration',
    description: 'Upgrade to accept payments for events and seminars.',
  },
  storePos: {
    title: 'Store & POS',
    description:
      'Upgrade to unlock point-of-sale checkout, inventory management, and a store dashboard for tracking products, sales, and stock.',
  },
  familyDiscounts: {
    title: 'Family discounts',
    description:
      'Family billing discounts use Stripe subscriptions. Upgrade to a paid plan to configure automatic family discounts.',
  },
  discountCodes: {
    title: 'Discount codes',
    description:
      'Promotional discount codes are managed through Stripe. Upgrade to a paid plan to create and share codes.',
  },
  automatedNotifications: {
    title: 'Automated notifications',
    description: 'Upgrade to enable automated payment and retention alerts.',
  },
  dataExport: {
    title: 'Data export',
    description: 'Export is available on your current plan.',
  },
  staffPayroll: {
    title: 'Staff payroll & time tracking',
    description:
      'Upgrade to let staff clock in from Student Sign-In, track hours worked, configure pay periods, view session history, and export payroll CSVs. Your free plan still includes the staff roster and shift scheduler.',
  },
};
